// extracted by mini-css-extract-plugin
export var cartIcon = "_jf-0";
export var cartIconContainer = "_jf-1";